import React from 'react'

/* Style */
import './Home.css'

/* Modules */
import { Link } from 'react-router-dom';
import TopBar from '../topBar/TopBar';

const HomeView = (props) => {
    return (
        <div>
            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className='HomeContent'>

                <p className='homeTitle'>
                    Bem vindo ao sistema Fúria Fight para gerenciamento de campeonatos de Jiu Jitsu
                </p>

                <p className='homeSubTitle'>
                    Escolha uma das opções abaixo
                </p>

                <div className='HomeCard'>
                    <Link
                        to={'/home/champs'}
                        style={{ color: 'rgba(0,0,0,0.65)' }}
                    >
                        <i className="fas fa-trophy" style={{ cursor: 'pointer' }}></i>
                        <div className='HomeCardTitle'>Campeonatos</div>
                    </Link>
                </div>

                <div className='HomeCard' style={{ marginLeft: 'inherit', cursor: 'pointer' }}>
                    <Link
                        to={'/home/events'}
                        style={{ color: 'rgba(0,0,0,0.65)' }}
                    >
                        <i className="fas fa-microphone"></i>
                        <div className='HomeCardTitle'>Eventos</div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default HomeView